import { render, staticRenderFns } from "./adminland.vue?vue&type=template&id=6ada833d&"
import script from "./adminland.vue?vue&type=script&lang=ts&"
export * from "./adminland.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports